export default __webpack_public_path__ + "static/media/ViewRSP_4D.b3295b66.png";